import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer>
            <nav className="footer-links">
                <Link to="/privacy">プライバシーポリシー</Link>
                <span className="footer-sep">|</span>
                <Link to="/disclaimer">免責事項</Link>
            </nav>
            <p>&copy; {year} Ruby Magic Corporation. All rights reserved.</p>
        </footer>
    );
};

export default Footer;